import { router } from "@inertiajs/vue3"
import { ref } from "vue"

import { deleteJson } from "@/lib/fetch"
import { itemLinkPath } from "@/routes"

function onLinked() {
  router.reload()
}

export function useItemLinks(itemId: string) {
  const linkOpen = ref(false)

  async function unlinkItem(targetId: string) {
    const res = await deleteJson(itemLinkPath(itemId, targetId))
    if (res.ok) router.reload()
  }

  return { linkOpen, unlinkItem, onLinked }
}
